import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TourCategoriesComponent } from './tour-categories.component';
import { MiniTourModule } from '../mini-tour/mini-tour.module';
import { MotePipesModule } from '../../pipes';
import { SvgIconModule } from '../svg-icon';
import { HorizontalScrollModule } from '../horizontal-scroll/horizontal-scroll.module';
import { LoadingComponentModule } from '../loading/loading.module';
import { RouterModule } from '@angular/router';


@NgModule({
    declarations: [
        TourCategoriesComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        MiniTourModule,
        MotePipesModule,
        SvgIconModule,
        HorizontalScrollModule,
        LoadingComponentModule
    ],
    exports: [
        TourCategoriesComponent
    ]
})
export class TourCategoriesModule { }
